module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-container"
  }, [_c('el-tabs', {
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "岗位实习现场指导记录表",
      "name": "first"
    }
  }, [(_vm.type === 'mobile') ? _c('div', [_c('el-form', {
    attrs: {
      "label-width": "100px",
      "label-position": "left",
      "width": "100%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "指导教师"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.teaName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "实习学生"
    }
  }, [(_vm.userType !== 'stu') ? _c('el-select', {
    attrs: {
      "placeholder": _vm.stuText,
      "multiple": "",
      "clearable": "",
      "disabled": _vm.stuFlag
    },
    on: {
      "change": _vm.changeStu
    },
    model: {
      value: (_vm.form.stuCode),
      callback: function($$v) {
        _vm.$set(_vm.form, "stuCode", $$v)
      },
      expression: "form.stuCode"
    }
  }, _vm._l((_vm.stuOption), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.form.stuName))])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "班级"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.className))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "单位名称"
    }
  }, [(_vm.userType !== 'stu') ? _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择实习单位"
    },
    on: {
      "change": _vm.changeUnit
    },
    model: {
      value: (_vm.form.unitName),
      callback: function($$v) {
        _vm.$set(_vm.form, "unitName", $$v)
      },
      expression: "form.unitName"
    }
  }, _vm._l((_vm.comboOption.unit), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.userType === 'stu') ? _c('span', [_vm._v(_vm._s(_vm.form.unitName))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "实习岗位"
    }
  }, [(_vm.userType !== 'stu') ? _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "placeholder": "请选择实习岗位"
    },
    model: {
      value: (_vm.form.postName),
      callback: function($$v) {
        _vm.$set(_vm.form, "postName", $$v)
      },
      expression: "form.postName"
    }
  }, _vm._l((_vm.tempPost), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.userType === 'stu') ? _c('span', [_vm._v(_vm._s(_vm.form.postName.join()))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "指导时间"
    }
  }, [(_vm.userType !== 'stu') ? _c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择指导时间",
      "type": "date",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.form.recordDate),
      callback: function($$v) {
        _vm.$set(_vm.form, "recordDate", $$v)
      },
      expression: "form.recordDate"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.userType === 'stu') ? _c('span', [_vm._v(_vm._s(_vm.form.recordDate))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "企业带教教师"
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系电话"
    }
  }), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-position": "top",
      "width": "100%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "指导内容"
    }
  }, [(_vm.userType !== 'stu') ? _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5,
      "maxlength": "500",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.form.content1),
      callback: function($$v) {
        _vm.$set(_vm.form, "content1", $$v)
      },
      expression: "form.content1"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.userType === 'stu') ? _c('span', [_vm._v(_vm._s(_vm.form.content1))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "企业带教教师交流记录"
    }
  }, [(_vm.userType !== 'stu') ? _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5,
      "maxlength": "500",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.form.content2),
      callback: function($$v) {
        _vm.$set(_vm.form, "content2", $$v)
      },
      expression: "form.content2"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.userType === 'stu') ? _c('span', [_vm._v(_vm._s(_vm.form.content2))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "现场指导情况总结"
    }
  }, [(_vm.userType !== 'stu') ? _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5,
      "maxlength": "500",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.form.content3),
      callback: function($$v) {
        _vm.$set(_vm.form, "content3", $$v)
      },
      expression: "form.content3"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.userType === 'stu') ? _c('span', [_vm._v(_vm._s(_vm.form.content3))]) : _vm._e()], 1)], 1)], 1)], 1) : _c('div', {
    staticStyle: {
      "height": "600px",
      "overflow": "auto",
      "margin-left": "20px"
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "width": "100%"
    }
  }, [_c('table', {
    staticClass: "tableStyle",
    attrs: {
      "border": "1",
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('col', {
    attrs: {
      "width": "81.13"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "80"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "60"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "82.47"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "80"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "121.53"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "60"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "160"
    }
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "line-height": "45px"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("\n                                    指导教师\n                                ")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("\n                                    " + _vm._s(_vm.form.teaName) + "\n                                ")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "font"
  }, [_vm._v("\n                                    实习学生\n                                ")])]), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [(_vm.userType !== 'stu') ? _c('el-select', {
    attrs: {
      "placeholder": _vm.stuText,
      "multiple": "",
      "clearable": "",
      "disabled": _vm.stuFlag
    },
    on: {
      "change": _vm.changeStu
    },
    model: {
      value: (_vm.form.stuCode),
      callback: function($$v) {
        _vm.$set(_vm.form, "stuCode", $$v)
      },
      expression: "form.stuCode"
    }
  }, _vm._l((_vm.stuOption), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.userType === 'stu') ? _c('span', {
    staticClass: "font"
  }, [_vm._v("\n                                    " + _vm._s(_vm.form.stuName) + "\n                                ")]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "font"
  }, [_vm._v("\n                                    班级\n                                ")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "font"
  }, [_vm._v("\n                                    " + _vm._s(_vm.form.className) + "\n                                ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "line-height": "45px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("\n                                    单位名称\n                                ")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [(_vm.userType !== 'stu') ? _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择实习单位"
    },
    on: {
      "change": _vm.changeUnit
    },
    model: {
      value: (_vm.form.unitName),
      callback: function($$v) {
        _vm.$set(_vm.form, "unitName", $$v)
      },
      expression: "form.unitName"
    }
  }, _vm._l((_vm.comboOption.unit), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.userType === 'stu') ? _c('span', {
    staticClass: "font"
  }, [_vm._v("\n                                    " + _vm._s(_vm.form.unitName) + "\n                                ")]) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "line-height": "45px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("\n                                    实习岗位\n                                ")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [(_vm.userType !== 'stu') ? _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "placeholder": "请选择实习岗位"
    },
    model: {
      value: (_vm.form.postName),
      callback: function($$v) {
        _vm.$set(_vm.form, "postName", $$v)
      },
      expression: "form.postName"
    }
  }, _vm._l((_vm.tempPost), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.userType === 'stu') ? _c('span', {
    staticClass: "font"
  }, [_vm._v("\n                                    " + _vm._s(_vm.form.postName.join()) + "\n                                ")]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "font"
  }, [_vm._v("\n                                    指导时间\n                                ")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [(_vm.userType !== 'stu') ? _c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择指导时间",
      "type": "date",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.form.recordDate),
      callback: function($$v) {
        _vm.$set(_vm.form, "recordDate", $$v)
      },
      expression: "form.recordDate"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.userType === 'stu') ? _c('span', {
    staticClass: "font"
  }, [_vm._v("\n                                    " + _vm._s(_vm.form.recordDate) + "\n                                ")]) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "line-height": "45px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("\n                                    企业带教教师\n                                ")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "font"
  }, [_vm._v("\n                                    联系电话\n                                ")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "colspan": "8"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("\n                                    指导内容：\n                                    "), _c('br'), _vm._v(" "), (_vm.userType !== 'stu') ? _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5,
      "maxlength": "500",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.form.content1),
      callback: function($$v) {
        _vm.$set(_vm.form, "content1", $$v)
      },
      expression: "form.content1"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.userType === 'stu') ? _c('div', {
    staticStyle: {
      "height": "115px",
      "overflow": "auto"
    }
  }, [_vm._v("\n                                        " + _vm._s(_vm.form.content1) + "\n                                    ")]) : _vm._e()], 1)])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "colspan": "8"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("\n                                    企业带教教师交流记录：\n                                    "), _c('br'), _vm._v(" "), (_vm.userType !== 'stu') ? _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5,
      "maxlength": "500",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.form.content2),
      callback: function($$v) {
        _vm.$set(_vm.form, "content2", $$v)
      },
      expression: "form.content2"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.userType === 'stu') ? _c('div', {
    staticStyle: {
      "height": "115px",
      "overflow": "auto"
    }
  }, [_vm._v("\n                                        " + _vm._s(_vm.form.content2) + "\n                                    ")]) : _vm._e()], 1)])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "colspan": "8"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("\n                                    现场指导情况总结：\n                                    "), _c('br'), _vm._v(" "), (_vm.userType !== 'stu') ? _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5,
      "maxlength": "500",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.form.content3),
      callback: function($$v) {
        _vm.$set(_vm.form, "content3", $$v)
      },
      expression: "form.content3"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.userType === 'stu') ? _c('div', {
    staticStyle: {
      "height": "115px",
      "overflow": "auto"
    }
  }, [_vm._v("\n                                        " + _vm._s(_vm.form.content3) + "\n                                    ")]) : _vm._e()], 1)])])])])], 1), _vm._v(" "), (_vm.userType === 'tea' && _vm.type !== 'mobile') ? _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "margin-bottom": "20px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveRec
    }
  }, [_vm._v("保 存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.callback
    }
  }, [_vm._v("关 闭")])], 1) : _vm._e()]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "现场指导照片",
      "name": "second"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "600px",
      "overflow": "auto"
    }
  }, [(_vm.imageFlag) ? _c('div', [(_vm.userType === 'stu') ? _c('el-upload', {
    class: 'hidden-Btn',
    attrs: {
      "accept": ".png,.jpeg,.jpg",
      "action": "",
      "http-request": _vm.uploadPhoto,
      "file-list": _vm.fileImgList,
      "list-type": "picture-card",
      "disabled": true,
      "on-preview": _vm.handlePictureCardPreview
    },
    scopedSlots: _vm._u([{
      key: "file",
      fn: function(ref) {
        var file = ref.file;

        return [_c('div', {
          staticClass: "el-upload-list__item-thumbnail"
        }, [_c('img', {
          attrs: {
            "width": "146px",
            "height": "146px",
            "src": file.url,
            "alt": ""
          }
        })]), _vm._v(" "), _c('span', {
          staticClass: "el-upload-list__item-actions"
        }, [_c('span', {
          staticClass: "el-upload-list__item-preview",
          on: {
            "click": function($event) {
              return _vm.handlePictureCardPreview(file)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-zoom-in"
        })]), _vm._v(" "), (_vm.userType !== 'stu') ? _c('span', {
          staticClass: "el-upload-list__item-delete",
          on: {
            "click": function($event) {
              return _vm.handleRemove(file)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        })]) : _vm._e()])]
      }
    }], null, false, 780988138)
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]) : (_vm.userType !== 'stu' && _vm.type !== 'mobile') ? _c('el-upload', {
    attrs: {
      "accept": ".png,.jpeg,.jpg",
      "action": "",
      "http-request": _vm.uploadPhoto,
      "file-list": _vm.fileImgList,
      "list-type": "picture-card",
      "on-preview": _vm.handlePictureCardPreview,
      "on-remove": _vm.handleRemove
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]) : _c('el-upload', {
    attrs: {
      "accept": "image/*",
      "action": "",
      "http-request": _vm.uploadPhoto,
      "before-upload": _vm.beforeUpload,
      "file-list": _vm.fileImgList,
      "list-type": "picture-card",
      "on-preview": _vm.handlePictureCardPreview,
      "on-remove": _vm.handleRemove
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v(" "), (_vm.previewerVisible) ? _c('previewer', {
    ref: "previewer",
    attrs: {
      "fileInfo": _vm.fileInfo,
      "widthPercent": 60,
      "heightNum": 650,
      "topNum": 60
    },
    on: {
      "closePreviewer": function($event) {
        _vm.previewerVisible = false;
      }
    }
  }) : _vm._e()], 1) : _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "font-size": "18px",
      "font-weight": "bold",
      "color": "#a7a8ac",
      "margin-top": "50px"
    }
  }, [_vm._v("\n                    首次保存现场指导记录后可上传照片\n                ")])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-490301b6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/postPracticeManage/recordTable.vue
// module id = 1821
// module chunks = 502